import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { issueNavigatorEntrypoint } from '@atlassian/jira-spa-apps-project-issue-navigator/entrypoint.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';
import {
	createPageEntryPoint,
	createChromelessEntryPoint,
} from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { issueNavigatorEmbedEntrypoint } from '@atlassian/jira-spa-apps-issue-navigator-embed/entrypoint.tsx';
import { nav4SidebarContentCoreEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-core/entrypoint.tsx';
import { nav4ProjectsContentEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-core/src/ui/projects/default/async-content/entrypoint.tsx';
import { nav4JSWProjectEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu/src/ui/jsw-expandable-project/async-content/entrypoint.tsx';
import { globalIssueNavigatorGinRedirectEntrypoint } from './gin-redirect/entrypoint.tsx';
import { issueNavigatorPinRedirectEntrypoint } from './pin-redirect/entrypoint.tsx';

export const globalIssueNavigatorGinRedirectPageEntryPoint = createPageEntryPoint({
	main: globalIssueNavigatorGinRedirectEntrypoint,
	topNavigationMenuId: MENU_ID.FILTERS,
});

export const issueNavigatorPageEntryPoint = createPageEntryPoint({
	main: issueNavigatorEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const issueNavigatorPageEntryPointWithNested = createPageEntryPoint({
	main: issueNavigatorEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: {
			projects: {
				entryPoint: nav4ProjectsContentEntryPoint,
			},
			boards: {
				entryPoint: nav4JSWProjectEntryPoint,
			},
		},
		isProjectsExpanded: true,
	},
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const issueNavigatorWithoutHorizontalNavPageEntryPoint = createPageEntryPoint({
	main: issueNavigatorEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const issueNavigatorPinRedirectPageEntryPoint = createPageEntryPoint({
	main: issueNavigatorPinRedirectEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const issueNavigatorEmbedPageEntryPoint = createChromelessEntryPoint({
	main: issueNavigatorEmbedEntrypoint,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyGlobalIssueNavigator = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-global-issue-navigator", jiraSpaEntry: "global-issue-navigator" */ '@atlassian/jira-spa-apps-global-issue-navigator'
		),
);
